const initState = {};

const usersReducer = (state = initState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default usersReducer;
